import {
  isSyntheticInfluencerEmail,
  isValidPlatformInviteEmail,
  SYNTHETIC_INFLUENCER_EMAIL_DOMAIN,
} from '../../shared/influencerInviteEmail.js'

export { SYNTHETIC_INFLUENCER_EMAIL_DOMAIN, isSyntheticInfluencerEmail, isValidPlatformInviteEmail }

/**
 * Roster table display: never show synthetic @placeholder.invalid addresses to users.
 * @returns {{ kind: 'empty' | 'synthetic' | 'real', label: string }}
 */
export function getRosterEmailDisplay(email) {
  const raw = String(email ?? '').trim()
  if (!raw) return { kind: 'empty', label: 'No email on file yet' }
  if (isSyntheticInfluencerEmail(raw)) return { kind: 'synthetic', label: 'No email on file yet' }
  return { kind: 'real', label: raw }
}

/**
 * Single-line display for tables/cards/dialogs: no synthetic placeholder, no bare UUID-style junk.
 * @param {string} [email]
 * @param {string} [emptyDisplay] — default em dash
 * @returns {string} Real address or emptyDisplay
 */
export function formatInfluencerEmailForDisplay(email, emptyDisplay = '—') {
  const raw = String(email ?? '').trim()
  if (!raw || isSyntheticInfluencerEmail(raw)) return emptyDisplay
  return raw
}
